import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import ElementInteraction from './element-interaction';

var CCElementInteraction = function CCElementInteraction(props) {
  var elementInteractionProps = _objectSpread({}, props, {
    eventName: 'CC_ELEMENT_INTERACTION_EVENT',
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    impressionId: props.impressionId
  });

  var ccData = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productId: props.productId,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productImpressionId: props.productImpressionId
  };
  return React.createElement(ElementInteraction, _extends({
    verticalInteractionData: ccData
  }, elementInteractionProps));
};

CCElementInteraction.propTypes = {
  productId: PropTypes.number.isRequired,
  impressionId: PropTypes.string,
  productImpressionId: PropTypes.string,
  productImpressionKey: PropTypes.string
};
export default CCElementInteraction;
var CCElementInteractionConnect = connect(function (state, ownProps) {
  return {
    impressionId: get(state, "impressions[".concat(ownProps.id, "].elementImpressionHeader.impressionId")),
    productImpressionId: get(state, "impressions[".concat(ownProps.productImpressionKey, "].impressionHeader.impressionId"))
  };
})(CCElementInteraction);
export { CCElementInteractionConnect };